import { ReactSVG } from 'react-svg';
import React, { Component, useState, createRef, useEffect } from 'react';
import { useGet } from '@/query/fetchHooks';
import './Svg.css';
import { restoreDrawioSvgMetadata } from './drawioSvgMetadata';

const Svg = ({ src, afterInjection }) => {
  const [svgData, setSvgData] = useState('');
  const ref = React.useRef(null);

  useGet(src, {
    onSuccess: (result) => {
      setSvgData(result?.data);
    },
  });

  useEffect(() => {
    if (ref.current && svgData) {
      const svg = ref.current.childNodes[0];
      svg.setAttribute('preserveAspectRatio', 'xMinYMin meet');

      restoreDrawioSvgMetadata(svg);

      let nodes = svg.querySelectorAll('*[data-name]');
      for (let node of nodes) {
        let name = node.getAttribute('data-name');
        try {
          if (!node.getAttribute('data-type')) {
            const typeNode = node.querySelector('*[data-type]');

            if (typeNode)
              node.dataset.type = typeNode.getAttribute('data-type');
          }
          // get this node's transform and its parent's
          const nodeTransform = node.getAttribute('transform');
          const parentTransform = node.parentNode?.getAttribute?.('transform');

          // only strip it if they’re exactly the same
          if (
            nodeTransform &&
            parentTransform &&
            nodeTransform === parentTransform
          ) {
            node.removeAttribute('transform');
          }
        } catch (e) {
          console.error(e);
        }
        try {
          let title = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'title'
          );
          title.innerHTML = name;
          node.prepend(title);
        } catch (e) {
          console.error(e);
        }
      }
      svg.style.colorScheme = undefined; //messes with diagrams.net
      afterInjection(ref.current.querySelector('svg'));

      /*
      window.$(`*[data-name]`, svg).each((i, elNode) => {
        let el = window.$(elNode);
        let name = el.data('name');
        console.log("name", name)
        try {
          let typeNodes = el.find('*[data-type]');
          let type;
          if (typeNodes.length > 0) {
            for (let i = typeNodes.length - 1; i >= 0; i--) {
              const node = typeNodes[i];
              type ||= node.dataset.type;
              delete node.dataset.type;
            }
          }
          if (type) {
            el[0].dataset.type = type;
          }
        } catch (e) {
          console.error(e);
        }
        let title = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'title'
        );
        title.innerHTML = name;
        el.prepend(title);
      });
      */

      afterInjection(svg);
    }
  }, [ref.current, svgData]);

  return (
    <div
      ref={ref}
      className="svg-parent"
      dangerouslySetInnerHTML={{ __html: svgData }}
    ></div>
  );
};

export { Svg };
